module.exports = __webpack_public_path__ + "img/search-result.12d8a008.svg";